import './chip.scss'
import templateUrl from './chip.html'

/**
 * Chip component.
 *
 * @example
 *   <tmr-chip label="Some string" icon="o-tick-sign-1" icon-size="16" status="success"></tmr-chip>
 *
 * @type {ngComponent}
 * @prop {string} label
 * @prop {string=} icon
 * @prop {16|24=} [icon-size=16]
 * @prop {'success'|'warning'|'error'} status
 */
export const tmrChip = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrChipController',
  bindings: {
    label: '@',
    icon: '@?',
    iconSize: '@?',
    status: '@?',
  },
}

/**
 * Controller of component {@link tmrChipController}.
 *
 * @type {ngController}
 */
export class tmrChipController {
  static ngType = 'controller'

  iconSize = 16

  colors = {
    success: { backgroundColor: 'temeraGreen', color: 'background' },
    warning: { backgroundColor: 'yellow' },
    error: { backgroundColor: 'warn', color: 'background' },
  }
}
